var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99997 17.227C13.7571 17.227 17.6135 13.3706 17.6135 8.6135C17.6135 3.85639 13.7571 0 8.99997 0C4.24287 0 0.386475 3.85639 0.386475 8.6135C0.386475 13.3706 4.24287 17.227 8.99997 17.227ZM8.99997 12.6936C11.2533 12.6936 13.08 10.8669 13.08 8.6135C13.08 6.36013 11.2533 4.53342 8.99997 4.53342C6.74661 4.53342 4.91989 6.36013 4.91989 8.6135C4.91989 10.8669 6.74661 12.6936 8.99997 12.6936Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepRound);
export default __webpack_public_path__ + "static/media/stepRound.71ad7a4b4350b565f7afe1cf87f38804.svg";
export { ForwardRef as ReactComponent };